import { useState, useEffect } from 'react';
import { useUser } from '../Auth/AuthContext';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Title from '../Shared/Title';
import Icon from '../Shared/Icon';
import InputAdornment from '@mui/material/InputAdornment';
import { FormControl, Input, InputLabel } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';

export default function ComboBox(props) {
    const user = useUser();
    // const val = props?.options?.find(x => x.value == props.value)
    // const [value, setValue] = useState(props?.options?.find(x => x.value == props.value))
    // const [value, setValue] = useState(props.value)
    // const [inputValue, setInputValue] = useState(props?.options?.find(x => x.value == props.value))
    // const [inputValue, setInputValue] = useState(props.value)
    const [value, setValue] = useState(null)
    const [inputValue, setInputValue] = useState(null)
    const options = props.options
    useEffect(() => {
        const val = props?.options?.find(x => x.value == props.value) || {}
        setValue(val)
        // setInputValue(val)
    }, [props]);

    return (
        <Autocomplete
            fullWidth
            disablePortal
            name={props.name}
            value={value}
            disabled={props.disabled || user.disabled}
            onChange={(event, newValue) => {
                newValue && props.handler({
                    target: {
                        name: props.name,
                        value: newValue.value
                    }
                })
            }}
            // onInputChange={(event, newInputValue) => {
            //     // console.log(newInputValue)
            //     setInputValue(newInputValue);
            // }}
            isOptionEqualToValue={
                (option, value) => option?.value === value?.value
            }
            options={props.options}
            getOptionLabel={option => option?.label || ''}
            renderOption={(props, option) => {
                return (
                    <li {...props}>
                        <Title
                            row
                            disabled
                            systems={option?.system && [option.system]}
                            icons={option?.icon && [option.icon]}
                            label={option?.label}
                        />
                    </li>
                )
            }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={props.label}
                    variant="standard"
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <InputAdornment position="start">
                                <Icon icon={value?.icon} system={value?.system} />
                                {/* <Icon icon={inputValue?.icon} system={inputValue?.system} /> */}
                            </InputAdornment>
                        )
                    }}
                />
            }
        />
    );
}